<div class="grid-1" [formGroup]="this.form">
  <app-progress-bar [totalSteps]="questions.length" [currentStep]="currentQuestionNumber()"></app-progress-bar>
  <app-card header="Vraag {{currentQuestionNumber()}}">
    <app-question [question]="questions[this.currentQuestionIndex]" [form]="form">></app-question>
    @if (this.form.hasError('required')) {
      <div class="text-primary">* Deze vraag is verplicht, vul eerst een antwoord in</div>
    }
    <app-button ngProjectAs="button" type="primary" (click)="submit()">
      @if (questions.length > currentQuestionNumber()) {
        <span>Volgende</span>
      }
      @if (questions.length === currentQuestionNumber()) {
        <span>Opslaan</span>
      }
    </app-button>
  </app-card>
</div>
